import omit from 'lodash/omit'
import api from 'api'
import { CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE, CACHE_TAG_DISPOSAL_FEES } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getDisposalFeesLinkedToConfiguredService: build.query({
      query: ({ id, includeArchived = true }) => ({
        url: `/api/v1/core/configured-service/${id}/fee/disposal`,
        method: 'GET',
        params: { includeArchived },
      }),
      providesTags: [CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE],
    }),
    getDisposalFeesLinkedToPricedService: build.query({
      query: ({ id, includeArchived = true }) => ({
        url: `/api/v1/core/priced-service/${id}/fee/disposal`,
        method: 'GET',
        params: { includeArchived },
      }),
      providesTags: [CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE],
    }),
    getPricedServicesLinkedToDisposalFee: build.query({
      query: ({ id }) => ({
        url: `/api/v1/core/fee/disposal/${id}/priced-services`,
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE],
    }),
    linkServicesToDisposalFee: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/api/v1/core/fee/disposal/${id}/link`,
        method: 'POST',
        body: { ...omit(rest, ['skipInvalidate']) },
      }),
      invalidatesTags: (result, error, body) =>
        body?.skipInvalidate ? [] : [CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE, CACHE_TAG_DISPOSAL_FEES],
    }),
    unlinkServicesFromDisposalFee: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/api/v1/core/fee/disposal/${id}/unlink`,
        method: 'POST',
        body: { ...omit(rest, ['skipInvalidate']) },
      }),
      invalidatesTags: (result, error, body) =>
        body?.skipInvalidate ? [] : [CACHE_TAG_SERVICES_LINKED_TO_DISPOSAL_FEE, CACHE_TAG_DISPOSAL_FEES],
    }),
  }),
})

export const {
  useLazyGetDisposalFeesLinkedToConfiguredServiceQuery,
  useLazyGetDisposalFeesLinkedToPricedServiceQuery,
  useLazyGetPricedServicesLinkedToDisposalFeeQuery,
  useLinkServicesToDisposalFeeMutation,
  useUnlinkServicesFromDisposalFeeMutation,
} = extendedApi
